import { h, Component } from "preact";
import { route } from 'preact-router';
import linkState from 'linkstate';
import style from "../../../../../style/admin";

import { getApiPath } from "../../../../../path";
import AdminMenu from "../../../../../components/admin/menu";
import AdminMenuFilm from "../../../../../components/admin/menu/film";

class AdminFilmEditImage extends Component {
  state = {
    literaturelist: [],
    formSubmitted: false,
    formValid: false,
    imageTooBig: false,
    formData: {
      afbeelding: "",
      id_titel: ""
    }
  };

  constructor(props){
    super(props);

    this.ApiGetInfo();
  }

  ApiGetInfo = () => {
    let fetchPath = getApiPath(this.props.lang, `adminFilm/itemsWithoutImage`);
    fetch(fetchPath, {
      method: 'get',
      headers: {
        "Authorization": sessionStorage.getItem("vumc-jwt")
      }
    })
    .then(res => res.json())
    .then(result => {
      if (result.status == 200) {
        this.setState(previousState => ({
          ...previousState,
          literaturelist: result.data["literature"]
        }))
    }});
  }

  fileRead = ({ target }) => {
    if(target.files[0].size < 220000){
      const fileReader = new FileReader();
      fileReader.readAsDataURL(target.files[0]);
      fileReader.onload = (e) => {
        this.state.formData.afbeelding = e.target.result;
      };
      this.setState(previousState => ({
        ...previousState,
        imageTooBig: false
      }));
    }else{
      this.setState(previousState => ({
        ...previousState,
        imageTooBig: true
      }));
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    
    this.setState(previousState => ({
      ...previousState,
      formSubmitted: true
    }), this.validateForm());
  }

  validateForm = () => {
    if ( // required fields
      this.state.formData.id_titel == "" || this.state.formData.afbeelding == "" || this.state.imageTooBig
    ) {
      this.setState(previousState => ({
        ...previousState,
        formValid: false
      }));
    }else{
      this.setState(previousState => ({
        ...previousState,
        formValid: true
      }), this.doSubmit());
    }
  }

  doSubmit = () => {
    let fetchPath = getApiPath(this.props.lang, `adminFilm/image`);
    fetch(fetchPath, {
      method: 'post',
      headers: {
        "Authorization": sessionStorage.getItem("vumc-jwt")
      },
      body: JSON.stringify(this.state.formData)
    })
    .then(res => res.json())
    .then(result => {
      if (result.status == 200) {
        window.location.reload();
      } else {
        alert("Something went wrong");
      }
    });
  }
  
  render() {
    return (
      <div class="admin-page">
        <AdminMenu locale={this.props.lang} />
        <AdminMenuFilm locale={this.props.lang} />
        <div>
          <h2>{this.props.lang=='nl'?'Upload afbeelding':'Upload image'}</h2>
          <article>
            <form class="admin-form" onSubmit={this.handleSubmit} enctype="multipart/form-data">

              <div class="form-group">
                <label for="afbeelding">{this.props.lang=='nl'?'Selecteer afbeelding om te uploaden':'Select image to upload'}</label>
                <input type="file" name="afbeelding" id="afbeelding" accept="image/jpeg, image/png, image/gif" onChange={this.fileRead} />
              </div>

              {this.state.imageTooBig &&
                <div class="form-group">
                    {this.props.lang=='nl'?'De geselecteerde afbeelding is te groot om toe te voegen':'The selected image is too large to add'}
                </div>
              }

              <div class="form-group">
                <label for="id_titel">Film</label>
                <select name="id_bid_titeloek" id="id_titel" value={this.state.formData.id_titel} onInput={linkState(this, 'formData.id_titel')}>
                  <option>{this.props.lang=='nl'?'Kies een film':'Choose a film'}</option>
                  {this.state.literaturelist.map(listItem => {
                    return (<option value={listItem.id_titel}>{listItem.titel}</option>);
                  })}
                </select>
              </div>

              {(this.state.formSubmitted && !this.state.formValid) &&
                <div class="form-group">
                  {this.props.lang=='nl'?'U dient &oacute;f een auteur &oacute;f een boek te selecteren voordat de afbeelding geupload kan worden':'You must select either an author or a book before the image can be uploaded'}
                    
                </div>
              }

              <div class="form-group">
                <button>{this.props.lang=='nl'? 'Opslaan':'Save'}</button>
              </div>
            </form>
          </article>
        </div>
      </div>
    )
  }
}

export default AdminFilmEditImage;